<template>
  <div>

    <TitlePage :title="$t('customers')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathDuplicate">
          <v-icon left>mdi-magnify</v-icon>
          Check Duplicati
        </v-btn>
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathNotifications">
          <v-icon left>mdi-mail</v-icon>
          Messaggi
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 align-center">
        <v-col cols="12" md="6">
          <v-text-field v-model="filter.search" :label="$t('search')" hide-details dense outlined clearable></v-text-field>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <v-row class="px-4 pt-2 pb-1 align-center" style="font-size: 13px; font-weight: 500;">
        <v-col cols="12" md="12" class="d-flex align-center flex-wrap">
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="green" text-color="white" class="mr-1" /> Confermate
          </div>
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="amber darken-2" text-color="white" class="mr-1" /> Da Confermare
          </div>
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="red" text-color="white" class="mr-1" /> Annullate
          </div>
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="black" text-color="white" class="mr-1" /> In Blacklist
          </div>
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="blue" text-color="white" class="mr-1" /> Codici Sconto
          </div>
          <div class="mr-4 d-flex align-center">
            <v-chip small dense color="deep-purple" text-color="white" class="mr-1" /> N° Promo SA
          </div>
        </v-col>
      </v-row>

      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer  @update:options="handleSort"
      >

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="details(item._id)" :title="$t('details')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-find</v-icon>{{ $t('details') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="getUser.super_admin" @click="editStats(item._id)" title="Modifica statistiche" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-chart-bar</v-icon>Modifica statistiche
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>{{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.active" inset @change="updateSingleStatus(item)" dense hide-details class="mt-0"></v-switch>
        </template>

        <template v-slot:item.email="{ item }">
          {{item.email}}
          <template v-if="item.email_verified">
            <v-icon color="primary">mdi-check-decagram</v-icon>
          </template>
        </template>

        <template v-slot:item.phone="{ item }">
          {{item.phone}}
          <template v-if="item.phone_verified">
            <v-icon color="primary">mdi-check-decagram</v-icon>
          </template>
        </template>

        <template v-slot:item.bookings_count_completed="{ item }">
          <a :href="`${baseUrl}/#/bookings?user_id=${item._id}`" target="_blank" >
            <v-chip color="green" text-color="white" small style="cursor: pointer">{{ item.bookings_count_completed || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.bookings_count_to_be_confirmed="{ item }">
          <a :href="`${baseUrl}/#/bookings?user_id=${item._id}`" target="_blank" >
            <v-chip color="amber darken-2" text-color="white" small style="cursor: pointer">{{ item.bookings_count_to_be_confirmed || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.bookings_count_canceled="{ item }">
          <a :href="`${baseUrl}/#/bookings?user_id=${item._id}`" target="_blank" >
            <v-chip color="red" text-color="white" small style="cursor: pointer">{{ item.bookings_count_canceled || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.count_blacklist="{ item }">
          <a :href="`${baseUrl}/#/blacklists?search=${encodeURIComponent(item.email)}`" target="_blank" >
            <v-chip color="black" text-color="white" small style="cursor: pointer">{{ item.count_blacklist || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.count_promo_code="{ item }">
          <a :href="`${baseUrl}/#/promo-codes?user_id=${item._id}`" target="_blank" >
            <v-chip color="blue" text-color="white" small style="cursor: pointer">{{ item.count_promo_code || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.bookings_count_promo_sa="{ item }">
          <a :href="`${baseUrl}/#/bookings?user_id=${item._id}&promo_sa_global=true&status=completed`" target="_blank" >
            <v-chip color="deep-purple" text-color="white" small style="cursor: pointer">{{ item.bookings_count_promo_sa || 0 }}</v-chip>
          </a>
        </template>

        <template v-slot:item.affidabilita="{ item }">
          <div class="termometro">
            <v-progress-linear
                :value="getReliabilityScore(item)"
                height="10"
                :color="getReliabilityColor(getReliabilityScore(item),item)"
                rounded
            />
            <small>{{ getReliabilityScore(item) }}%</small>
          </div>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import { getReliabilityScore, getReliabilityColor } from '@/utils/reliability';


const exportService = require('@/services/export')

export default {
  name: 'Customers',
  components: {ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      pathCreate: '/customers/create/',
      pathDuplicate: '/customers/duplicates/',
      pathNotifications: '/customers/notifications/',
      pathEdit: '/customers/edit/',
      pathDetails: '/customers/details/',
      search: '',
      selected: [],
      headers: [
        // { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('name'), align: 'start', value: 'name', sortable: false},
        { text: this.$t('surname'), align: 'start', value: 'surname', sortable: false},
        { text: this.$t('email'), align: 'start', value: 'email',sortable: false},
        { text: this.$t('phone'), align: 'start', value: 'phone', sortable: false},
        { text: '✔️', value: 'bookings_count_completed', sortable: true},
        { text: '⏳', value: 'bookings_count_to_be_confirmed', sortable: true },
        { text: '❌', value: 'bookings_count_canceled', sortable: true },
        { text: '⛔', value: 'count_blacklist', sortable: true },
        { text: '🎁', value: 'count_promo_code', sortable: true },
        { text: '🐖', value: 'bookings_count_promo_sa', sortable: true },
        { text: 'Affidabilità', value: 'affidabilita', sortable: false },
        { text: this.$t('status'), value: 'status', sortable: false},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100],
    };
  },
  async created(){
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(); }, 350);
  },
  watch: {
    filter: {
      handler() {
        this._debouncedSearch();
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      'getFilter':'customers/getFilter',
      'getOptionsPagination':'customers/getOptionsPagination',
      'getUser':'user/getUser'
    }),
    baseUrl() {
      return window.location.origin;
    }
  },
  methods: {
    debounce(fn, wait){
      var t=null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },
    getReliabilityColor,
    getReliabilityScore,
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'customers/index',
      'updateItem':'customers/update',
      'deleteItem': 'customers/delete',
      'massiveDeleteItem': 'customers/massDelete',
      'setFilter': 'customers/setFilter',
      'setOptionsPagination': 'customers/setOptionsPagination',
    }),

    async resetFilter(){
      var filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    details(id){
      this.$router.push(this.pathDetails+id)
    },

    editStats(id){
      this.$router.push(`/match-stats/user-override?user_id=${id}`)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems(this.getOptionsPagination);
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems(this.getOptionsPagination);
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {active: item.active, email: item.email}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async getNewPage(){
      await this.makeSearch()
    },
    calculatePagination(count, limit){

      var divide = (count / limit)
      var rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    handleSort(options) {
      if (options.sortBy.length > 0) {
        const sort_field = options.sortBy[0];
        const sort_order = options.sortDesc[0] ? 'desc' : 'asc';
        this.options_pagination.sort_field = sort_field;
        this.options_pagination.sort_order = sort_order;
        this.makeSearch(true); // ricomincia da pagina 1
      }
    },

  },
  mounted() {

  },
}
</script>

<style>
.termometro {
  min-width: 100px;
}
.termometro small {
  display: block;
  font-size: 11px;
  text-align: right;
  margin-top: 2px;
  font-weight: bold;
}

</style>
